import {Contrato} from "./contrato";
import {Unidade} from "./unidade";
import {CapituloRim} from "./capitulo-rim";

export class Rim {
    id: number;
    contrato: Contrato;
    unidade: Unidade;
    dataInicio: Date;
    dataFim: Date;
    modeloPadrao: boolean;
    finalizado: boolean;

    capitulos: CapituloRim[];
}